/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  ContactTimeline,
  ContactTimelineFromJSON,
  ContactTimelineFromJSONTyped,
  ContactTimelineToJSON
} from './ContactTimeline'
import { PageInfo, PageInfoFromJSON, PageInfoFromJSONTyped, PageInfoToJSON } from './PageInfo'

/**
 *
 * @export
 * @interface ContactTimelinesResponseData
 */
export interface ContactTimelinesResponseData {
  /**
   *
   * @type {Array<ContactTimeline>}
   * @memberof ContactTimelinesResponseData
   */
  contactTimelines?: Array<ContactTimeline>
  /**
   *
   * @type {PageInfo}
   * @memberof ContactTimelinesResponseData
   */
  pageInfo?: PageInfo
}

export function ContactTimelinesResponseDataFromJSON(json: any): ContactTimelinesResponseData {
  return ContactTimelinesResponseDataFromJSONTyped(json, false)
}

export function ContactTimelinesResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ContactTimelinesResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactTimelines: !exists(json, 'contact_timelines')
      ? undefined
      : (json['contact_timelines'] as Array<any>).map(ContactTimelineFromJSON),
    pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
  }
}

export function ContactTimelinesResponseDataToJSON(value?: ContactTimelinesResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_timelines:
      value.contactTimelines === undefined
        ? undefined
        : (value.contactTimelines as Array<any>).map(ContactTimelineToJSON),
    page_info: PageInfoToJSON(value.pageInfo)
  }
}
